/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Recording_Show_IndicatorInputs */

const en_forms_users_settings_recording_show_indicator = /** @type {(inputs: Forms_Users_Settings_Recording_Show_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicator`)
};

const de_forms_users_settings_recording_show_indicator = /** @type {(inputs: Forms_Users_Settings_Recording_Show_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufzeichnungs-Indikator anzeigen`)
};

/**
* | output |
* | --- |
* | "Indicator" |
*
* @param {Forms_Users_Settings_Recording_Show_IndicatorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_recording_show_indicator = /** @type {((inputs?: Forms_Users_Settings_Recording_Show_IndicatorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Recording_Show_IndicatorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_recording_show_indicator(inputs)
	return de_forms_users_settings_recording_show_indicator(inputs)
});